module.exports = {"sorry":"Tyvärr gick något fel.","tryagain":"Testa att ladda om"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/sv-SE/strings.json
// module id = 1180
// module chunks = 0